import React from 'react';
import Pagination from "rc-pagination";
import { locale } from "../../common/table/paginatorConfig";
import { ICustomerCard, ICustomerCardType } from "../../models/customer-card";
import { IPageResponse } from 'common/interfaces/IPageResponse';
import { Form, Spinner } from 'react-bootstrap';
import { CustomerPermission, useAuthContext } from 'services/context/authentication.context';
import { isNotNullOrUndefined } from '../../common/data-util';

interface CustomerCardsTableProps {
    customerCards: IPageResponse<ICustomerCard> | null;
    onPageChange?: (page: number) => void;
    onCardEdit: (card: ICustomerCard) => void;
    onViewPin: (card: ICustomerCard) => void;
    onCardActivate?: (card: ICustomerCard) => void;
    isRequesting: boolean;
    activated: boolean;
    selectedCardNumbers?: string[];
    onCardSelect?: (remoteCardId: string) => void;
    onSelectAll?: () => void;
}

export function CustomerCardsTable(props: CustomerCardsTableProps) {
    const { hasPermission, state } = useAuthContext();

    const customerCards: Array<ICustomerCard> | null = props.customerCards ? props.customerCards.content : null;
    const pageResponse = props.customerCards;

    if (!customerCards || !pageResponse) return <></>;

    const isWebAdmin = hasPermission(CustomerPermission.WEB_ADMIN);
    
    const customerCardsTableRows = customerCards.map((customerCard: ICustomerCard) =>
        <tr key={'row-' + customerCard.remoteCardId + '_' + customerCard.name}>
            {
                !props.activated && isWebAdmin && (
                    <td>
                        <Form.Check
                            id={`doc-check-${customerCard.remoteCardId}`}
                            custom
                            type="checkbox"
                            label=""
                            className='mt-2 mb-n1'
                            onChange={() => props.onCardSelect?.(customerCard.remoteCardId)}
                            checked={props.selectedCardNumbers?.includes(customerCard.remoteCardId) ?? false}
                        />
                    </td> 
                )
            }                               
            <td>
                <div className="customer-cards__card-types">
                    <div className='icon__all-products mr-2 icon' />
                </div>
            </td>
            <td className={customerCard.isExpired ? 'card-expired' : ''}>
                {customerCard.remoteCardId}{ customerCard.isExpired ? <small> (aegunud {customerCard.dateExpiry})</small> : ''}
            </td>
            <td className="text-nowrap">
                {customerCard.name}
            </td>
            <td>
                {isNotNullOrUndefined(customerCard.monthlyLimit) ? customerCard.monthlyLimit : "-"}
            </td>
            <td>
                {customerCard.creditUsed !== null ? (customerCard.creditUsed).toFixed(2) : ""}
            </td>
            <td>
                {
                    isWebAdmin && (
                        <div className="row__actions d-flex align-items-center">
                            {
                                props.activated ? (
                                <>
                                    <button 
                                        className="button-action"
                                        onClick={() => props.onCardEdit(customerCard)} 
                                    >
                                        Muuda
                                    </button>
                                    {
                                        !customerCard.isBlocked && customerCard.cardType === ICustomerCardType.PAYMENT_CARD && state.customer.canViewPin && (
                                            <button 
                                                className="button-action ml-2"
                                                onClick={() => props.onViewPin(customerCard)}
                                            >
                                                Vaata PINi
                                            </button>
                                        )
                                    }
                                </>
                        ) : (
                            <button 
                                className="button-action"
                                onClick={() => props.onCardActivate?.(customerCard)}
                                disabled={(props.selectedCardNumbers?.length ?? 0) > 1}
                            >
                                Aktiveeri
                            </button>
                        )
                    }
                        </div>
                    )
                }
            </td>
        </tr>
    );
    
    return (
        <div className="table__container scroll-icon-md">
            <table className={`customer-cards__table table table-responsive-md table-hover ${!props.activated ? 'mb-0' : ''}`}>
                <thead>
                    <tr>
                        {
                            !props.activated && isWebAdmin && (
                                <th>
                                    <Form.Check
                                        id={'doc-check-all'}
                                        custom
                                        type="checkbox"
                                        label=""
                                        className='mt-2 mb-n1'
                                        onChange={() => props.onSelectAll?.()}
                                        checked={customerCards != null && customerCards.length > 0 && props.selectedCardNumbers?.length === customerCards.length}
                                    />
                                </th>
                            )
                        }
                        <th>Tüüp</th>
                        <th>Kaardi number</th>
                        <th>Kaardi nimi</th>
                        <th>Limiit</th>
                        <th>Kasutatud krediit</th>
                        <th>{ hasPermission(CustomerPermission.WEB_ADMIN) ? 'Tegevused' : '' }</th>
                    </tr>
                </thead>
                <tbody>
                {props.isRequesting ?
                <tr>
                    <td colSpan={7}>
                        <div className="p-4 w-100 d-flex align-items-center justify-content-center">
                            <Spinner animation="grow" />
                        </div>
                    </td>
                </tr> :
                customerCardsTableRows}                    
                </tbody>
                <tfoot>
                    {pageResponse ? <tr>
                        <td colSpan={7}>
                            <div className="pagination-wrapper">
                                <Pagination
                                    locale={locale}
                                    current={pageResponse.number + 1}
                                    total={pageResponse.totalElements}
                                    pageSize={pageResponse.size}
                                    prefixCls={"pagination"}
                                    onChange={props.onPageChange}
                                    showSizeChanger={false}
                                    hideOnSinglePage={true}
                                />
                            </div>
                        </td>
                    </tr> : null}
                </tfoot>
            </table>
        </div>
    )
}